import React, { Component } from 'react'
import {
  DataGrid,
  GridColumn,
  Panel,
  DateBox,
  ComboBox,
  LinkButton,
  TextBox,
  Messager,
  Link,
  ButtonGroup

} from "rc-easyui";
import PropTypes from "prop-types";
import { API_URL } from "../../constants";
import { getCookie, getAccessToken } from "../../helpers/cookieHelper";
import { isEmpty, getFormattedDate } from "../../helpers";
import { autoDissaperAction } from "../../helpers/index";

const axios = require("axios");
export default class ViewScriptDetail extends Component {
  static propTypes = {
    selectedRow: PropTypes.object,
    OnEditClick: PropTypes.func,
    onSelectionChange: PropTypes.func,
    permissions: PropTypes.array,
    type: PropTypes.array,
    status: PropTypes.array,
    // clientsList: PropTypes.array,
  };
  constructor(props) {
    super(props);


    this.state = {
      data: [],
      pageOptions: {},
      searchparam: {
        tablename: "",
        type: "",
        status: "",
        modulename: ""
      },
      isLoading: false,
      pageOptions: {
        pageOptions: {
          layout: [
            "list",
            "sep",
            "first",
            "prev",
            "next",
            "last",
            "sep",
            "refresh",
            "sep",
            "manual",
            "info",
          ],
        },
      },
    };
    this.refereshData = this.refereshData.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.searchFieldOnChange = this.searchFieldOnChange.bind(this);
    this.deleteRow = this.deleteRow.bind(this)
    // this.getClientPaymentInfo = this.getClientPaymentInfo.bind(this);
  }

  componentDidMount() {
    this.setState(
      {
        pageOptions: {
          loading: true,
          pageOptions: {
            pageNumber: 1,
            pageSize: 20,
            layout: [
              "list",
              "sep",
              "first",
              "prev",
              "next",
              "last",
              "sep",
              "refresh",
              "sep",
              "manual",
              "info",
            ],
          },
        },
      },
      () => {
        this.refereshData();
      }
    );
  }


  async refereshData() {
    const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
    const { tablename, status, type, modulename } = this.state.searchparam;
    //console.log(pageNumber);
    //console.log(pageSize);
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };

    var url = `${API_URL}api/getscriptdetailforpagination?tablename=${tablename}&status=${status}&type=${type}&modulename=${modulename}&rows=${pageSize}&page=${pageNumber}`;
    // var url = API_URL + "api/priceplanspagination?row=10&page=0";
    if (access_token != null) {
      this.setState({
        pageOptions: {
          pageOptions: {
            ...this.state.pageOptions.pageOptions,
          },
          loading: true,
        },
      });
      axios
        .get(url, axiosConfig)
        .then((response) => {
          console.log(response)
          if (response.status === 200) {
            var data = response.data.rows;
            var total = response.data.total;

            this.setState({
              data: data,
              pageOptions: {
                pageOptions: {
                  pageSize: 10,
                  total: total,
                  pageList: Array.from(new Set([20, 50, 30, 100, total])).sort(
                    function (a, b) {
                      return a - b;
                    }
                  ),
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
            this.clearSearch()
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.refereshData();
      }
    }
  }

  async deleteRow() {

    let token = getCookie("access_token");
    this.messager.confirm({
      title: "Confirm",
      msg: "Are you want to delete this?",
      result: async (r) => {
        if (r) {
          if (JSON.stringify(token) === "null") {
            const resp = await getAccessToken();
            if (resp) {
              this.deleteRoleData(this.props.selectedRow.id);

            }
          } else {
            this.deleteRoleData(this.props.selectedRow.id);

          }
        }
      },
    });
  }

  deleteRoleData(id) {
    let tokenType = getCookie("token_type");
    let token = getCookie("access_token");
    let apiUrl = `${API_URL}api/deletescriptdetail/${id}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    let self = this;
    self.setState({
      isLoading: true,
    });
    axios
      .delete(apiUrl, headersConfig)
      .then(function (response) {
        //console.log("response", response);
        if (response.status === 200) {
          self.setState({
            isLoading: false,
          });
          if (response.data !== "") {
            if (response.data.status === true) {

              alert(`${response.data.message}`);
              self.refereshData();
            } else {
              self.setState({
                isLoading: false,
              });
              alert(`${response.data.message}`);
            }
          } else {
            alert("Internal Server Error!!");
          }
        }
      })
      .catch(function (error) {
        //console.log("error", error);
        let response = error["response"];
        if (response !== undefined) {
          if (response.status === 400) {
            var message = "";
            response.data.errors.forEach((row, i) => {
              message +=
                "<p style='margin-bottom:3px;'>" + row.defaultMessage + "</p>";
            });

          } else {
            alert("Uncaught Error");
          }
        } else {
          alert("Internal Server Error");
        }
        self.setState({
          isLoading: false,
        });
      });
  }

  onPageChange(event) {
    delete event["refresh"];
    delete event["filterRules"];

    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
          loading: true,
        },
      },
      function () {
        this.refereshData();
      }
    );
  }

  clearSearch = () => {
    let clearSearchs = {
      tablename: "",
      type: "",
      status: "",
      modulename: ""
    }
    this.setState({
      searchparam: clearSearchs
    })
  }

  searchFieldOnChange(name, e) {
    let searchparam = Object.assign({}, this.state.searchparam);

    searchparam[name] = e;
    this.setState({ searchparam: searchparam });

  }



  render() {
    const searchparam = this.state.searchparam;
    const isLoading = this.state.isLoading;
    return (
      <div>
        <Panel
          title='Show Detail List'
          bodyStyle={{ padding: 0 }}
          style={{ height: 640 }}
        >
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType='none'
            content={({ title, msg, buttons, reload }) => (
              <div className='alert-content'>
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className='m-buttons'>
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <div
            className='loadingmodel'
            style={{ display: isLoading ? "block" : "none" }}
          ></div>
          <DataGrid
            data={this.state.data}
            style={{ height: 610 }}
            selectionMode='single'
            {...this.state.pageOptions}
            pagination
            {...this.props.selectedRow}
            onSelectionChange={(selection) =>
              this.props.onSelectionChange(selection)
            }
            onPageChange={this.onPageChange}
            toolbar={({ editingItem }) => (
              <div style={{ padding: 4 }}>
                <b>Table Name </b>&nbsp;
                <TextBox
                  value={searchparam.tableName}
                  style={{ width: 200 }}
                  onChange={(e) => this.searchFieldOnChange("tablename", e)}
                ></TextBox>
                &nbsp;

                <b>Type</b>&nbsp;
                <ComboBox
                  data={this.props.type}
                  valueField='value'
                  textField='text'
                  value={searchparam.type}
                  editable={false}
                  onChange={(e) => this.searchFieldOnChange("type", e)}
                ></ComboBox>
                &nbsp;
                <b>Status</b>&nbsp;
                <ComboBox
                  data={this.props.status}
                  valueField='value'
                  textField='text'
                  value={searchparam.status}
                  editable={false}
                  onChange={(e) => this.searchFieldOnChange("status", e)}
                ></ComboBox>
                &nbsp;
                <b>Module Name </b>&nbsp;
                <TextBox
                  value={searchparam.moduleName}
                  style={{ width: 200 }}
                  onChange={(e) => this.searchFieldOnChange("modulename", e)}
                ></TextBox>
                &nbsp;
                <LinkButton
                  iconCls='icon-search'
                  plain
                  onClick={this.refereshData}
                >
                  Search
                </LinkButton>
                {this.props.permissions.includes("technical-access-edit") ? (
                  <LinkButton
                    iconCls='icon-edit'
                    plain
                    disabled={isEmpty(this.props.selectedRow)}
                    onClick={this.props.OnEditClick}
                  >
                    Edit
                  </LinkButton>)
                  : null}
                {this.props.permissions.includes("technical-access-delete") ? (
                  <LinkButton
                    iconCls='icon-remove'
                    disabled={isLoading ? true : false}
                    plain
                    disabled={isEmpty(this.props.selectedRow)}
                    onClick={this.deleteRow}
                  >
                    Delete
                  </LinkButton>) : null}

              </div>
            )}
          >
            {/* <GridColumn
              field='rn'
              align='center'
              width='30px'
              cellCss='datagrid-td-rownumber'
              render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
            /> */}
            <GridColumn
              width={70}
              field='id'
              title='Id'
              align='center'
            />

            <GridColumn
              width={150}
              field='modulesDetail'
              title='Module Detail'
              align='center'
            ></GridColumn>


            <GridColumn
              width={250}
              field='tableName'
              title='Table Name'
              align='center'
            ></GridColumn>
            <GridColumn
              width={310}
              field='script'
              title='Script'
              align='center'
            ></GridColumn>
            <GridColumn
              width={130}
              field='type'
              title='Type'
              align='center'
            ></GridColumn>

            <GridColumn
              width={130}
              field='status'
              title='Status'
              align='center'
            ></GridColumn>

          </DataGrid>
        </Panel>
      </div>
    )
  }
}
